import { ApiBaseName } from '@Enum/index';

export const deciderOfApprovePathName = (service: string): string => {
  switch (service) {
    case 'HRMRequest':
      return `${ApiBaseName.ESS}/hrm-request`;
    case 'IT Requisition':
      return `${ApiBaseName.ESS}/it-requisition`;
    case 'Resignation Request':
      return `${ApiBaseName.ESS}/resignation-request`;
    default:
      return `${ApiBaseName.ESS}/hrm-request`;
  }
};
